//
//
//
//
//
//
//
//
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
  name: 'pdfH5',
  data: function data() {
    return {
      visible: false,
      pdfh5: null
    };
  },
  methods: {
    openPdf: function openPdf(url) {
      this.visible = true; //实例化

      this.pdfh5 = new Pdfh5("#preViewPdf", {
        pdfurl: url,
        maxZoom: 3,
        // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/', // 使用外部字体文件2.5.207版本
        cMapUrl: "./pdfjs-dist/cmaps/",
        cMapPacked: true
      }); //监听PDF加载完成事件，加载成功，加载失败都会触发

      this.pdfh5.on('complete', function (status, msg, time) {
        console.log('状态：' + status + ',消息：' + msg + ',耗时：' + time + '毫秒');
      });
    },
    downloadPdf: function downloadPdf(url) {
      this.visible = true; //实例化

      this.pdfh5 = new Pdfh5("#preViewPdf", {
        pdfurl: url,
        maxZoom: 3,
        // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/', // 使用外部字体文件2.5.207版本
        cMapUrl: "./pdfjs-dist/cmaps/",
        cMapPacked: true
      }); //监听PDF加载完成事件，加载成功，加载失败都会触发

      this.pdfh5.on('complete', function (status, msg, time) {
        console.log('状态：' + status + ',消息：' + msg + ',耗时：' + time + '毫秒');
      });
      console.log("开始下载");
      this.pdfh5.download();
    }
  }
};